// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__33qiU","content":"ManualTimeModal_content__3gnJD"};